export const common = {
  nav: {
    products: 'Produits',
    gallery: 'Galerie',
    services: 'Services',
    technologies: 'Technologies',
    industries: 'Industries',
    about: 'À Propos',
    contact: 'Contact',
    requestStudy: 'Demander une Étude',
    toggleMenu: 'Ouvrir le menu',
  },
  footer: {
    description: 'Fournisseur leader de solutions avancées de filtration industrielle, de purification et de séparation pour les industries mondiales.',
    isoCertified: 'Qualité Certifiée ISO',
    solutions: 'Solutions',
    company: 'Entreprise',
    contact: 'Contact',
    followUs: 'Suivez-nous',
    address: 'Adresse',
    phone: 'Téléphone',
    email: 'Email',
    businessHours: 'Heures d\'Ouverture',
    privacyPolicy: 'Politique de Confidentialité',
    termsOfService: 'Conditions d\'Utilisation',
    cookiePolicy: 'Politique de Cookies',
    allRightsReserved: 'Tous droits réservés.',
    poweredBy: 'Propulsé par Bradnova',
    steEinaLtdInternational: 'Ste EINA LTD International',
  },
  actions: {
    learnMore: 'En Savoir Plus',
    viewAll: 'Voir Tout',
    exploreSolutions: 'Explorer les Solutions',
    discoverMore: 'Découvrir Nos Solutions',
    contactUs: 'Contactez-nous',
    viewProducts: 'Voir les Produits',
    exploreProducts: 'Explorer Tous les Produits',
  },
  language: {
    english: 'English',
    french: 'Français',
    selectLanguage: 'Sélectionner la Langue',
  },
};